import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Config } from "../../config";


@Component({
    selector: 'app-custom-domain-redirect',
    templateUrl: './custom-domain-redirect.component.html',
    styleUrls: ['./custom-domain-redirect.component.scss']
  })

  export class CustomDomainRedirectComponent implements OnInit {
    private config = new Config();
    constructor(private activatedRoute : ActivatedRoute){}
    ngOnInit(){
        let customDomainData = this.activatedRoute.snapshot.data["customDomainData"];
        let paramsObj:any = {};
        if(customDomainData && customDomainData !== ""){
          let urlToOpen:string;
          if(customDomainData.search(this.config.WebUrl) >= 0){
            urlToOpen = window.location.origin + customDomainData.replace(/^(https?|ftp):\/\//g,"").replace(this.config.WebUrl,"");
          }else{
            urlToOpen = customDomainData;
          }
          this.activatedRoute.queryParams.subscribe(params => {
            paramsObj = JSON.parse(JSON.stringify(params));
          });
          if(paramsObj && Object.keys(paramsObj).length > 0){
            if(urlToOpen.indexOf("?") < 0){
              urlToOpen += "?";
            }
            else{
              urlToOpen += "&";
            }
    
            for (let key in paramsObj) {
              urlToOpen += key + "=" + paramsObj[key] + "&";
            }
            urlToOpen = urlToOpen.replace(/&$/g,"");
          }
          window.open(urlToOpen,"_self");
          return false;
        }
    }



  }


// WEBPACK FOOTER //
// ./src/app/custom-domain-redirect/custom-domain-redirect.component.ts